import { Link } from "@tanstack/react-router";
import { Banknote, CalendarDays, ListTodo, Menu, Users } from "lucide-react";

export function AppMobileNav({ onOpenMenu }: { onOpenMenu: () => void }) {
	return (
		<nav aria-label="Navegação rápida" className="app-mobile-nav">
			<Link
				to="/"
				activeOptions={{ exact: true }}
				className="mobile-nav-item"
				activeProps={{ className: "bg-primary-soft text-primary" }}
			>
				<ListTodo className="size-5" />
				Agora
			</Link>
			<Link
				to="/pessoas"
				className="mobile-nav-item"
				activeProps={{ className: "bg-primary-soft text-primary" }}
			>
				<Users className="size-5" />
				Pessoas
			</Link>
			<Link
				to="/agenda"
				className="mobile-nav-item"
				activeProps={{ className: "bg-primary-soft text-primary" }}
			>
				<CalendarDays className="size-5" />
				Agenda
			</Link>
			<Link
				to="/financeiro"
				className="mobile-nav-item"
				activeProps={{ className: "bg-primary-soft text-primary" }}
			>
				<Banknote className="size-5" />
				Financeiro
			</Link>
			<button
				type="button"
				onClick={onOpenMenu}
				className="mobile-nav-item"
				aria-label="Abrir menu"
			>
				<Menu className="size-5" />
				Mais
			</button>
		</nav>
	);
}
